<template>
  <v-container class="mt-8">
    <div>
      <v-row wrap justify="center">
        <v-col cols="12" md="6">
          <h2 class="text-h5 text-md-h4 accent--text" style="font-weight: bold">
            Encomendar Caderno de Encargo
          </h2>
        </v-col>
      </v-row>
    </div>
    <v-card style="margin-top: 20px; margin-bottom: 80px;">
      <v-card-title>
        <h4 class="text-h6 text-md-h5 accent--text" style="font-weight: bold">Detalhes do Pedido:</h4>
      </v-card-title>
      <v-card-text>
        <v-row wrap justify="right">
          <v-col cols="12" md="9">
            <p>
              Concurso: <strong>{{ orderBook.content.titulo }}</strong>  
            </p>  
            <p>
              Preço:<strong> {{ orderBook.price }} MZN</strong>
            </p>
            <p>
              Taxa:<strong> 500.00 MZN</strong>
            </p>
            <p>
              Total a pagar:<strong> {{ orderBook.price_total }} MZN, inc IVA.</strong>
            </p>
          </v-col> 
        </v-row>
        <v-row wrap justify="center">
            <v-col cols="12" md="12">
                <v-row wrap justify="center">
                    <v-col cols="12" md="9">
                    <h2 class="title">Métodos de Pagamento</h2>
                    </v-col>
                </v-row>
                <v-row wrap justify="center">
                    <!-- <div class="payment-method"> -->
                    <v-col cols="12" md="9">
                        <v-select v-model="metodoPagamento" :items="items" label="Escolha um método de Pagamento" item-text="meth" item-value="code"></v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div style="margin-bottom: 4px" class="pa-2 mb-auto" v-if="metodoPagamento == 1">
            <v-row wrap justify="center" class="mt-6">
              <h6 class="text-h6 text-md-h5 accent--text" style="font-weight: bold">
                Concluir Pagamento da encomenda do Caderno de Encargo
              </h6>
            </v-row>

            <v-row wrap justify="center">
              <v-col cols="12" md="12">
                <p class="text-center">
                  Para  concluir o pagamento da encomenda do caderno de encargo, por favor, siga os passos abaixo.
                </p>
              </v-col>
              
              <v-col cols="12" md="9">
                <p>
                  Introduza o número M-pesa que usará para efectuar o pagamento.
                </p>
              </v-col> 
            </v-row>

            <v-row wrap justify="center">
              
              <v-col cols="12" md="9">
                <v-text-field v-model="telefone" placeholder="84/85 XXX XXXX" prefix="+258"></v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-btn dark color="#E20613" @click="pagarMpesa" block>
                  <img src="../../assets/pagarMpesa.png" height="auto" width="90" />
                  Pague {{ orderBook.price_total }} Mts
                </v-btn>
              </v-col>
              <v-col cols="12" md="9">
                <h4>Em caso de dificuldades siga os passos abaixo.</h4>
              </v-col>
              <v-col cols="12" md="9">
                <ol>
                  <li>Digita*150#;</li>
                  <li>Escolhe a opção 6-Pagamentos;</li>
                  <li>Selecciona 7-Digitar o código de serviço;</li>
                  <li>Digita o código do serviço 901277;</li>
                  <li>Digita a referência {{ id }}CE;</li>
                  <li>Digita o valor a pagar {{ orderBook.price_total }} Mts;</li>
                  <li>Digita o teu PIN;</li>
                  <li>Confirma a transação.</li>
                </ol>
              </v-col>
              <v-col cols="12" md="12">
                <p class="text-center">
                  Após confirmar a transação envie o comprovativo através do WhatsApp 84 543 6085 ou por email para comercial@marrar.co.mz
                </p>
              </v-col>
            </v-row>
          </div>
          <div style="margin-bottom: 4px" class="pa-2 mb-auto" v-if="metodoPagamento == 2">
            <v-row wrap justify="center">
              <h6 class="text-h6 text-md-h5 accent--text" style="font-weight: bold">
                Concluir Pagamento da encomenda do Caderno de Encargo
              </h6>
            </v-row>
            <v-row wrap justify="center" style="margin-bottom: 100px; margin-top: 50px;">
              <div class="text-justify-left text-body-2 text-md-body-1">
                <span>
                  Para pagar {{ orderBook.price_total }} MZN do caderno de encargo, por favor, faça uma transferência bancária ou depósito para a conta abaixo:
                </span>
                <p>
                  <span style="font-weight: bold">Banco:</span> Absa
                            Bank Moçambique Número
                </p>
                <p>
                  <span style="font-weight: bold">Número da Conta:</span>
                            0003102011227
                </p>
                <p>
                  <span style="font-weight: bold">NIB: </span>
                            000200030310201122720
                </p>
                <p>
                   <span style="font-weight: bold">Titular: </span>
                            Marrar Limitada
                </p>
                <p style="margin-top: 40px;">
                  Envie o email que usa na plataforma e o comprovativo de pagamento para o número 844181881 (Whatsapp) ou para o email comercial@marrar.co.mz.
                </p>
                <p style="margin-top: 20px;">
                  Logo a seguir sua conta já estará activa para ver todos os concursos na plataforma Gugla Empresas.
                </p>
              </div>
            </v-row>
            
          </div>
        </v-card-text>
    </v-card>
    <div>

        
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import { API } from "../../services/api";
import Swal from "sweetalert2";
export default {
    data() {
        return {
            id: this.$route.params.id,
            orderBook: {
              content: {
                id: null,
                titulo: '',
              },
              type: '',
              content_id: '',
              price: 0.00,
              price_total: 0.00,
            },
            metodoPagamento: 0,
            telefone: "",
            items: [
                { meth: "M-pesa", code: 1 },
                { meth: "Transferência Bancária / Depósito ", code: 2 },
            ],
            validation_notes: [
              {
                code: 1,
                description: ``,
              },
              {
                code: 2,
                description: `Envie o email que usa na plataforma e o comprovativo de pagamento para o número 844181881 (Whatsapp) ou para o email comercial@marrar.co.mz.`,
              },
              {
                code: 3,
                description: `Logo a seguir sua conta já estará activa para ver todos os concursos na plataforma Gugla Empresas.`,
              },
            ],
        };
    },
    created() {
        this.getOrder();
    },
    methods: {
        pagarMpesa() {
          // Swal.fire({
          //       icon: "warning",
          //       title: "Oops...",
          //       text: "Desativado no ambiente dev!",
          //       footer: '<a href="#">Contact o suporte em caso de dificuldades</a>'
          //     });
          this.$store.dispatch("loaderChange", true);
          axios.post(`${API}/recruiters/recruiter/book_payment`, {
              numero_telefone: this.telefone,
              caderno_id: this.orderBook.id,
          }).then(res => {
                Swal.fire({
                  icon: "success",
                  title: "Sucesso!",
                  text: "Pagamento realizado com sucesso!",
                  footer: '<a href="#">Contact o suporte em caso de duvidas ou dificuldades</a>'
                }).then(() => {
                  this.$router.push({ name: 'site.contents' });
                });
          }).catch(error => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Erro ao processar pagamento!",
                footer: '<a href="#">Contact o suporte em caso de dificuldades</a>'
              });
          }).finally(() => {
              this.$store.dispatch("loaderChange", false);
          });
        },
        getOrder() {
          this.$store.dispatch("loaderChange", true);
          axios.get(`${API}/recruiters/recruiter/order_book/${this.id}`)
            .then(response => {
              this.orderBook = response.data;
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error interno!",
                footer: '<a href="#">Contact o suporte em caso de dificuldades</a>'
              });
             // console.error("Error fetching order:", error);
            }).finally(() => {
              this.$store.dispatch("loaderChange", false);
            });
        }
    }
}
</script>

<style>

</style>